import React from 'react';
import { MainLayout } from '@layouts';
import { withUser } from '@modules/auth';
import { getHome } from '@modules/get-data';
import { getHomeJsonLd } from '@libs/get-structured-data';
import { HOSTNAME } from '@constants';
import { FirstScreen } from '@sections/First-Screen';
import { InternalNavigation } from '@sections/Internal-Navigation';
import { BeginningProject } from '@sections/Beginning-Project';
import { VisualizationConcept } from '@sections/Visualization-Concept';
import { NeuralNetwork } from '@sections/Neural-Network';
import { VirtualTour } from '@sections/Virtual-Tour';
import { WorkingDocumentation } from '@sections/Working-Documentation';
import { FinalTouch } from '@sections/Final-Touch';
import { Opportunities } from '@sections/Opportunities';
import { DirectSpeech } from '@sections/Direct-Speech';
import { Authors } from '@sections/Authors';
import { B2B } from '@sections/B2B';
import { AssistanceTraining } from '@sections/Assistance-Training';
import { FAQ } from '@sections/FAQ';
import { FirstProject } from '@sections/First-Project';

const Home = ({ directSpeech, main_faq, locale = '' }) => {
  return (
    <>
      <FirstScreen />
      <InternalNavigation />
      <BeginningProject />
      <VisualizationConcept />
      <NeuralNetwork />
      <VirtualTour />
      <WorkingDocumentation />
      <FinalTouch />
      <Opportunities locale={locale.toLowerCase()} />
      <DirectSpeech slides={directSpeech} />
      <Authors />
      {locale.toLowerCase() === 'ru' && <B2B />}
      <AssistanceTraining locale={locale.toLowerCase()} />
      <FAQ data={main_faq} />
      <FirstProject />
    </>
  );
};

Home.getLayout = (page) => {
  const { translations, main_faq = [], locale = '' } = page.props;
  const currentLocale = locale.toLowerCase() || 'ru';
  const title = translations.t('site.home.title');
  const description = translations.t('site.description.main');
  const jsonLd = getHomeJsonLd({
    hostname: HOSTNAME,
    locale: currentLocale,
    title,
    description,
    faqData: main_faq,
  });

  return (
    <MainLayout
      title={title}
      ogImage="/images/home/beginning/3d-ru-2x.jpg"
      meta={() => (
        <>
          <link
            rel="preload"
            as="image"
            type="image/webp"
            href="/images/first-screen-bg-mob.webp"
            media="(max-width: 1023px)"
            fetchPriority="high"
          />
          <link
            rel="preload"
            as="image"
            type="image/webp"
            href="/images/first-screen-bg-x1.webp"
            media="(min-width: 1024px) and (max-resolution: 1.4dppx)"
            fetchPriority="high"
          />
          <link
            rel="preload"
            as="image"
            type="image/webp"
            href="/images/first-screen-bg-x2.webp"
            media="(min-width: 1024px) and (min-resolution: 1.5dppx)"
            fetchPriority="high"
          />
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd).replace(/</g, '\\u003c') }}
          />
        </>
      )}
      isDarkMode={true}
      isTransparentHeader={true}
      isNoFixedHeader={true}
      isHideOnScrollHeader={true}
      wideHeader={true}>
      {page}
    </MainLayout>
  );
};

Home.getInitialProps = async (props) => {
  const { store } = props;
  const { dispatch } = store;

  return await dispatch(getHome());
};

Home.independentOfUser = true;

export default withUser(Home);
